import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

import { WHITE } from "constants/colors";

type Props = {
  text: string;
  color: string;
};

type PropsStyles = {
  color: string;
};

const useStyles = makeStyles(() =>
  createStyles({
    textLabel: (props: PropsStyles) => ({
      fontSize: "14px",
      fontWeight: "normal",
      fontStretch: "normal",
      fontStyle: "normal",
      lineHeight: "16px",
      letterSpacing: "normal",
      color: props.color ? props.color : WHITE,
      margin: "0px",
    }),
  })
);

const Label = ({ text, color }: Props) => {
  const classes = useStyles({ color });

  return (
    <>
      <Typography className={classes.textLabel} variant="h6" display="block" gutterBottom>
        <span>{text}</span>
      </Typography>
    </>
  );
};

export default Label;
